import {getRequest, postRequest} from "../../../../middlewares/api/actions";
import {
    getDatasetsUrl,
    getDatasetUrl,
    getDdbConnectionsUrl,
    getDsdUrl,
    getMappingSetPreviewTokenUrl,
    getMappingSetPreviewRemoveTempTableUrl,
    getMappingSetUrl,
    getTableViewDataPreviewUrl,
    saveMappingSetUrl,
    validateMappingSetMappingUrl,
    getStruvalInformationUrl,
    validateMappingSetDataUrl,
    validateMappingSetDatasetUrl,
    validateMappingSetFormatUrl, getMappingSetPreviewDataUrl
} from "../../../../constants/urls";
import {getArtefactTripletFromUrn} from "../../../../utils/sdmxJson";

export const MAPPING_SET_GET_DDB_CONNECTIONS = 'MAPPING_SET_GET_DDB_CONNECTIONS';
export const MAPPING_SET_GET_DATASETS = 'MAPPING_SET_GET_DATASETS';
export const MAPPING_SET_SELECT_CONNECTION = 'MAPPING_SET_SELECT_CONNECTION';
export const MAPPING_SET_SELECT_DATASET = 'MAPPING_SET_SELECT_DATASET';
export const MAPPING_SET_UPDATE_FIELDS = 'MAPPING_SET_UPDATE_FIELDS';
export const MAPPING_SET_RESET_FIELDS = 'MAPPING_SET_RESET_FIELDS';
export const MAPPING_SET_DESELECT_DATASET = 'MAPPING_SET_DESELECT_DATASET';
export const MAPPING_SET_WIZARD_QUERY_PREVIEW_ROWS_READ = 'MAPPING_SET_WIZARD_QUERY_PREVIEW_ROWS_READ';
export const MAPPING_SET_WIZARD_QUERY_PREVIEW_COLUMN_ROWS_READ = 'MAPPING_SET_WIZARD_QUERY_PREVIEW_COLUMN_ROWS_READ';
export const MAPPING_SET_WIZARD_COLUMN_SELECT = 'MAPPING_SET_WIZARD_COLUMN_SELECT';
export const MAPPING_SET_GET_DSD_INFO = 'MAPPING_SET_GET_DSD_INFO';
export const MAPPING_SET_WIZARD_DSD_COLUMN_SELECT = 'MAPPING_SET_WIZARD_DSD_COLUMN_SELECT';
export const MAPPING_SET_WIZARD_HIDE = 'MAPPING_SET_WIZARD_HIDE';
export const MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT = 'MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT';
export const MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD = 'MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD';
export const MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL = 'MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL';
export const MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE = 'MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE';
export const MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL = 'MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL';
export const MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_STASH = 'MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_STASH';
export const MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_TIME_MAPP_ALERT = 'MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_TIME_MAPP_ALERT';
export const MAPPING_SET_WIZARD_SAVE_MAPPING_SET = 'MAPPING_SET_WIZARD_SAVE_MAPPING_SET';
export const MAPPING_SET_WIZARD_GET_MAPPING_SET = 'MAPPING_SET_WIZARD_GET_MAPPING_SET';
export const MAPPING_SET_WIZARD_GET_MAPPING_TOKEN = 'MAPPING_SET_WIZARD_GET_MAPPING_TOKEN';
export const MAPPING_SET_WIZARD_GET_MAPPING_SET_PREVIEW = 'MAPPING_SET_WIZARD_GET_MAPPING_SET_PREVIEW';
export const MAPPING_SET_WIZARD_DELETE_STASH_ROW = 'MAPPING_SET_WIZARD_DELETE_STASH_ROW';
export const MAPPING_SET_WIZARD_RESET_SAVE_STATUS = 'MAPPING_SET_WIZARD_RESET_SAVE_STATUS';
export const MAPPING_SET_WIZARD_RESET_VALIDATIONS = 'MAPPING_SET_WIZARD_RESET_VALIDATIONS';
export const MAPPING_SET_FORCE_TREE_REFRESH = 'MAPPING_SET_FORCE_TREE_REFRESH';
export const MAPPING_SET_CHECK_STRUVAL = 'MAPPING_SET_CHECK_STRUVAL';
export const MAPPING_SET_WIZARD_VALIDATE_FORMAT = 'MAPPING_SET_WIZARD_VALIDATE_FORMAT';
export const MAPPING_SET_WIZARD_VALIDATE_MAPPING = 'MAPPING_SET_WIZARD_VALIDATE_MAPPING';
export const MAPPING_SET_WIZARD_VALIDATE_DATA = 'MAPPING_SET_WIZARD_VALIDATE_DATA';
export const MAPPING_SET_WIZARD_VALIDATE_DATASET = 'MAPPING_SET_WIZARD_VALIDATE_DATASET';
export const MAPPING_SET_WIZARD_VALIDATE_FORMAT_STATUS_ON_EXIT_CLEAR = 'MAPPING_SET_WIZARD_VALIDATE_FORMAT_STATUS_ON_EXIT_CLEAR';
export const MAPPING_SET_WIZARD_CLEAR_UPDATE_PREVIEW_FLAG = 'MAPPING_SET_WIZARD_CLEAR_UPDATE_PREVIEW_FLAG';
export const MAPPING_SET_WIZARD_CLEAR_MAPPING_SET_PREVIEW = 'MAPPING_SET_WIZARD_CLEAR_MAPPING_SET_PREVIEW';

export const clearMappingPreviewMappingSet = (token) => postRequest(
    MAPPING_SET_WIZARD_CLEAR_MAPPING_SET_PREVIEW,
    getMappingSetPreviewRemoveTempTableUrl(),
    {
        dataflowId: "",
        agency: "",
        version: "",
        page:0,
        token,
        filter:null,
    }
);

export const clearUpdatePreviewFlagMappingSet = () => ({
    type: MAPPING_SET_WIZARD_CLEAR_UPDATE_PREVIEW_FLAG
})

export const clearValidateFormatStatusOnExitMappingSet = () => ({
    type: MAPPING_SET_WIZARD_VALIDATE_FORMAT_STATUS_ON_EXIT_CLEAR
})

export const validateMappingSetDataset = (Agency, Version1, Version2, DataflowId, MappingsetId) => postRequest(
    MAPPING_SET_WIZARD_VALIDATE_DATASET,
    validateMappingSetDatasetUrl(),
    {Agency, Version1, Version2, DataflowId, MappingsetId}
)

export const validateMappingSetData = (Agency, Version1, Version2, DataflowId, MappingsetId) => postRequest(
    MAPPING_SET_WIZARD_VALIDATE_DATA,
    validateMappingSetDataUrl(),
    {Agency, Version1, Version2, DataflowId, MappingsetId}
)

export const validateMappingSetMapping = (Agency, Version1, Version2, DataflowId, MappingsetId) => postRequest(
    MAPPING_SET_WIZARD_VALIDATE_MAPPING,
    validateMappingSetMappingUrl(),
    {Agency, Version1, Version2, DataflowId, MappingsetId}
)

export const validateMappingSetFormat = (Agency, Version1, Version2, DataflowId, MappingsetId) => postRequest(
    MAPPING_SET_WIZARD_VALIDATE_FORMAT,
    validateMappingSetFormatUrl(),
    {Agency, Version1, Version2, DataflowId, MappingsetId}
)

export const checkStruval = () => getRequest(
    MAPPING_SET_CHECK_STRUVAL,
    getStruvalInformationUrl()
)

export const forceTreeRefreshMappingSet = () => ({
    type: MAPPING_SET_FORCE_TREE_REFRESH
})

export const resetSaveStatusMappingSet = (forValidation = false) => ({
    type: MAPPING_SET_WIZARD_RESET_SAVE_STATUS,
    forValidation,
})

export const getMappingSetDeleteStashRow = (row) => ({
    type: MAPPING_SET_WIZARD_DELETE_STASH_ROW,
    row
});

export const resetMappingSetValidations = (row) => ({
    type: MAPPING_SET_WIZARD_RESET_VALIDATIONS,
    row
});

export const getMappingSetPreviewData = (pageNum, pageSize, filters, sortCol, sortByDesc, token) => postRequest(
    MAPPING_SET_WIZARD_GET_MAPPING_SET_PREVIEW,
    getMappingSetPreviewDataUrl(token),
    {PageNum: pageNum, PageSize: pageSize, FilterTable: filters, SortCols: sortCol, SortByDesc: sortByDesc,}
);

export const getMappingSetPreviewToken = (dataflowId, dataflowAgency, dataflowVersion, token, page = 1, filter = null) => postRequest(
    MAPPING_SET_WIZARD_GET_MAPPING_TOKEN,
    getMappingSetPreviewTokenUrl(),
    {
        dataflowId: dataflowId,
        agency: dataflowAgency,
        version: dataflowVersion,
        page,
        token,
        filter,
    }
);

export const getMappingSetObject = (mappId) => getRequest(
    MAPPING_SET_WIZARD_GET_MAPPING_SET,
    getMappingSetUrl(mappId)
)

export const saveMappingSetOnServer = (mappingSetData, forValidation = false, isSilent = false) => ({
    ...postRequest(
        MAPPING_SET_WIZARD_SAVE_MAPPING_SET,
        saveMappingSetUrl(),
        mappingSetData,
        !isSilent ? t => ({
            success: t('scenes.mappingHandler.MappingSet.wizard.steps.third.saveSuccessful')
        }) : undefined
    ),
    forValidation
});

export const hideTimeMappingAlert = () => ({
    type: MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_TIME_MAPP_ALERT
});

export const stashMappingSetWizardComponentMapperComponent = () => ({
    type: MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_STASH,
});

export const addMappingSetWizardComponentMapperComponent = (singleColumn, constantValue) => ({
    type: MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD,
    constantValue,
    singleColumn
});
export const removeMappingSetWizardComponentMapperComponent = (columnName, dsdColumnName) => ({
    type: MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE,
    columnName,
    dsdColumnName
});
export const removeAllMappingSetWizardComponentMapperComponent = () => ({
    type: MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL
});
export const addAllMappingSetWizardComponentMapperComponent = () => ({
    type: MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL
});

export const selectMappingSetWizardComponentMapperComponent = (mapping) => ({
    type: MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT,
    mapping
});

export const selectMappingSetWizardDsdColumn = (columnName, multiplesAllowed) => ({
    type: MAPPING_SET_WIZARD_DSD_COLUMN_SELECT,
    columnName,
    multiplesAllowed
});
export const hideWizard = () => ({
    type: MAPPING_SET_WIZARD_HIDE,
});

export const fetchDsdInfoMappingSet = urn => {
    return getRequest(
        MAPPING_SET_GET_DSD_INFO,
        getDsdUrl(getArtefactTripletFromUrn(urn))
    )
}

export const selectMappingSetWizardColumn = (columnName, multiplesAllowed) => ({
    type: MAPPING_SET_WIZARD_COLUMN_SELECT,
    columnName,
    multiplesAllowed
});

export const readMappingSetWizardQueryColumnPreviewRows = (connId, limit, page, query, searchText, filters, sortCol, sortByDesc, colName) => ({
    ...postRequest(
        MAPPING_SET_WIZARD_QUERY_PREVIEW_COLUMN_ROWS_READ,
        getTableViewDataPreviewUrl(),
        {
            ConnectionId: connId,
            Limit: limit,
            Page: page,
            Query: query,
            SearchText: searchText,
            Filters: filters,
            SortCol: sortCol,
            SortByDesc: sortByDesc
        }
    ),
    colName
});

export const readMappingSetWizardQueryPreviewRows = (connId, limit, page, query, searchText, filters, sortCol, sortByDesc) => postRequest(
    MAPPING_SET_WIZARD_QUERY_PREVIEW_ROWS_READ,
    getTableViewDataPreviewUrl(),
    {
        ConnectionId: connId,
        Limit: limit,
        Page: page,
        Query: query,
        SearchText: searchText,
        Filters: filters,
        SortCol: sortCol,
        SortByDesc: sortByDesc
    }
);

export const resetFieldsMappingSet = fields => ({
    type: MAPPING_SET_RESET_FIELDS,
    fields,
});

export const updateFieldsMappingSet = fields => ({
    type: MAPPING_SET_UPDATE_FIELDS,
    fields,
});

export const selectDatasetMappingSet = (selectedDataset, shouldEraseStash = false) => !selectedDataset ? {
    type: MAPPING_SET_DESELECT_DATASET,
    shouldEraseStash
} : {
    ...getRequest(
        MAPPING_SET_SELECT_DATASET,
        getDatasetUrl(selectedDataset.id)
    ),
    shouldEraseStash
};

export const selectConnectionMappingSet = (selectedConnection, shouldEraseStash = false) => ({
    type: MAPPING_SET_SELECT_CONNECTION,
    selectedConnection,
    shouldEraseStash
});

export const getDatasetsMappingSet = (connId, username) => {
    return getRequest(
        MAPPING_SET_GET_DATASETS,
        getDatasetsUrl(connId, username),
    )
}

export const getDdbConnectionsMappingSet = ({
                                                username,
                                                permissions,
                                                token,
                                                email,
                                                metadataFlow,
                                                dataflow,
                                                isAuthenticated,
                                                dbbConnections
                                            }) => {

    return postRequest(
        MAPPING_SET_GET_DDB_CONNECTIONS,
        getDdbConnectionsUrl(),
        {
            username,
            permissions,
            token,
            email,
            metadataFlow,
            dataflow,
            isAuthenticated,
            dbbConnections
        }
    )
}
